import React from "react";
import styled from "styled-components";
import SingleProject from "./SingleProject";
import icon1 from "../assets/images/project-icon1.svg";
import icon2 from "../assets/images/project-icon2.svg";
import icon3 from "../assets/images/project-icon3.svg";

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  position: relative;
  padding: 100px 20px 0px 20px;

  h2 {
    margin-bottom: 50px;
    text-align: center;
    color: white;
  }
  .projects {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    max-width: 864px;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
  }

  @media (max-width: 799px) {
    margin-top: 35%;
    .projects-start h2 {
      font-size: 3.5rem;
      line-height: 1;
    }
    .projects {
      flex-direction: column;
    }
  }
  @media (max-width: 575.98px) {
    padding: 0;
    .title {
      font-size: 8vw;
      line-height: 1;
    }
  }
`;

const Projects = () => {
  return (
    <StyledSection id="projects-start">
      <h2 className="title">Recent work and experiments</h2>
      <section className="projects">
        <SingleProject
          width="48"
          color="#a2f6cf"
          technologies={["React", "Node.js", "Python", "FastAPI", "Docker", "MongoDB"]}
          icon={icon3}
          title="FlowFrame"
          year="2025"
          git="https://github.com/zaynchow"
        >
          AI-powered agile project management platform with a FastAPI ML
          microservice. Uses sentence-transformers and cosine similarity to
          match tasks to developers by skill, experience, and workload. Fully
          Dockerized with one-command deployment.
        </SingleProject>
        <SingleProject
          title="Craton"
          width="48"
          icon={icon2}
          technologies={["Next.js 15", "NestJS", "PostgreSQL", "BullMQ", "Redis"]}
          color="#AEE8FA"
          year="2026"
          git="https://github.com/zaynchow"
        >
          A platform that detects and visualizes consistency gaps between design
          systems and production code, helping engineering teams maintain UI
          integrity at scale. Built in a Turborepo monorepo with async job
          processing.
        </SingleProject>
        <SingleProject
          title="Momen Real Estates"
          width="100"
          icon={icon1}
          color="#f9f9f9"
          year="2025"
          technologies={["Next.js", "Sanity.io", "Google Maps API"]}
          git="https://github.com/zaynchow"
        >
          Responsive real estate listing platform with live Google Maps
          integration, server-side rendering, and CMS-driven content via
          Sanity.io.
        </SingleProject>
      </section>
    </StyledSection>
  );
};

export default Projects;
